import FundraiserPage from "src/pages/Fundraiser";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { getFundraiserServerSideProps } from "src/utilities/ssr/getFundraiserServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getFundraiserServerSideProps
);

export default withPropsDeserialization(FundraiserPage);
